document.addEventListener('DOMContentLoaded', (e) => {
	// Harbor Campaign Featured Leaders slider
	if (document.querySelector('#hc-featured-report-slider')) {
		jQuery(
			'#hc-featured-report-slider .view-harbor-campaign-reports .view-content'
		)
			.not('.slick-initialized')
			.slick({
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 3,
				prevArrow:
					'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><span class="visually-hidden">Next</span><span class="a-icon__left_arrow"></span></button>',
				nextArrow:
					'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><span class="visually-hidden">Next</span><span class="a-icon__right_arrow"></span></button>',
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						},
					},
					{
						breakpoint: 740,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						},
					},
					{
						breakpoint: 590,
						settings: {
							arrows: false,
							centerMode: false,
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			});
	}

	// Harbor Campaign Custom sliders
	if (
		document.querySelector(
			'#hc-content-slides .field--name-field-hc-content-slides'
		) &&
		document.querySelector(
			'#hc-content-slides .field--name-field-hc-content-slides'
		).children.length > 1
	) {
		jQuery('#hc-content-slides .field--name-field-hc-content-slides')
			.not('.slick-initialized')
			.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow:
					'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><span class="visually-hidden">Next</span><span class="a-icon__left_arrow"></span></button>',
				nextArrow:
					'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><span class="visually-hidden">Next</span><span class="a-icon__right_arrow"></span></button>',
			});
	}
});
